import React from 'react';

import Confirm from 'components/Confirm';
import Message from 'components/Message';

import { messages } from './FCFModeSelection.messages';

const BulkFCFModeConfirm = () => (
  <Confirm
    title={<Message message={messages.bulkFCFModeConfirmTitle} />}
    acceptNode={<Message message={messages.bulkFCFModeConfirmAccept} />}
    cancelNode={<Message message={messages.bulkFCFModeConfirmCancel} />}>
    <Message message={messages.bulkFCFModeConfirmBody} />
  </Confirm>
);

export default BulkFCFModeConfirm;
